<script setup lang="ts">
import { ref, watch } from 'vue'
import UiButton from './UiButton.vue'
import UiDialog from './UiDialog.vue'
import UiTextarea from './UiTextarea.vue'

// Confirmation (the alert style of UiDialog). With `reasonLabel`, asks for a text first (e.g. "Motivo
// da recusa") and only confirms with it filled in; `confirm` carries it.
const props = withDefaults(
  defineProps<{
    open: boolean
    title: string
    confirmLabel: string
    cancelLabel: string
    destructive?: boolean
    loading?: boolean
    reasonLabel?: string
  }>(),
  { reasonLabel: undefined },
)

const emit = defineEmits<{ confirm: [reason: string]; cancel: [] }>()

const reason = ref('')
watch(
  () => props.open,
  (open) => {
    if (open) reason.value = ''
  },
)
</script>

<template>
  <UiDialog :open="open" :title="title" size="alert" :close-label="cancelLabel" @close="emit('cancel')">
    <slot />
    <UiTextarea v-if="reasonLabel" v-model="reason" :label="reasonLabel" :rows="3" class="ui-confirm__reason" />
    <template #footer>
      <UiButton variant="gray" :disabled="loading" @click="emit('cancel')">{{ cancelLabel }}</UiButton>
      <UiButton
        :tone="destructive ? 'destructive' : 'default'"
        :loading="loading"
        :disabled="!!reasonLabel && !reason.trim()"
        @click="emit('confirm', reason.trim())"
      >
        {{ confirmLabel }}
      </UiButton>
    </template>
  </UiDialog>
</template>

<style scoped>
.ui-confirm__reason {
  margin-top: 12px;
  text-align: left;
}
</style>
